import ErrorPageModule from './ErrorPageModule'

export default ErrorPageModule
